import React, { useEffect } from 'react'
import Header from "../../components/layout/Header";
import HeaderLink from "../../components/layout/HeaderLink";
import MainSection from '../../components/common/MainSection';
import ServicesSection from '../../components/common/ServicesSection';
import CategoriesSection from '../../components/common/CategoriesSection';
import AboutSection from '../../components/common/AboutSection';
import ProductSection from '../../components/common/ProductsSection';
import WhyUsSection from '../../components/common/WhyUsSection';
import Footer from '../../components/layout/Footer';
import PartnersSection from '../../components/common/PartnersSection';
import OurMissionSection from '../../components/common/OurMissionSection';


function Home() {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <div>
        <MainSection />
    
        
    </div>
  )
}

export default Home